import React from 'react';
import Modal from 'react-modal';
import { FaSpinner } from 'react-icons/fa';
import './WaitingModal.css';

Modal.setAppElement('#root');

const LoadingModal = ({ isActive }) => {
  return (
    <Modal
      isOpen={isActive}
      onRequestClose={() => {}}
      contentLabel="Loading Modal"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderRadius: '5px',
          border: 'none',
          padding: '20px',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(26, 27, 28, 0.7)',
          width: '100%',
          height: '100%',
        },
      }}
    >
      <FaSpinner size={60} className="spinner" />
    </Modal>
  );
};

export default LoadingModal;
